import { RequestService } from '../../../../../common/services/RequestService';
import { MODELS_BY_KEYS_BRANDS_GET } from '../../constants';

export const getModelsByBrandsKeysRequest = payload => {
  return RequestService.get(
    `${MODELS_BY_KEYS_BRANDS_GET}/${JSON.stringify(payload)}`
  );
};
